export const CHAT_GPT_EDITOR_PROPS = Object.freeze(
  {
    KNOWLEDGE_BASE: {
      id: 'knowledgeBase',
      label: 'Knowledge base',
      tooltip: 'What the AI answers from. Leave it at <b>None</b> for a general answer.',
      productTooltip: 'The product feed the AI recommends products from.'
    },
    INSTRUCTIONS: {
      id: 'prompt',
      label: 'Instructions',
      tooltip: `
        What the AI should do in this answer. For example:
        <i class="block">
          Reply to questions regarding shoes. On any question, which doesn't regard shoes,
          reply as follows: I am sorry, I answer only questions about shoes.
        </i>
      `
    },
    // PRO-740: the product answer's Instructions — optional, the recommendation rules are built in
    PRODUCT_INSTRUCTIONS: {
      id: 'prompt',
      label: 'Instructions',
      placeholder: 'Optional. E.g. Ask about budget, size and intended use. Prefer Adidas when products fit equally well.',
      tooltip: `
        Optional. What to ask about and anything specific to your shop, on top of the built-in recommendation rules.
        For example:
        <i class="block">
          Ask about budget, size and intended use. Prefer Adidas when products fit equally well.
        </i>
      `
    },
    TOP_N_DOCUMENTS: {
      tooltip: `
        <b>Top N Documents</b> is number between 3 to 15.
        Use this to specify the number of top-scoring documents from your data index to generate responses.
      `,
      id: 'topNDocuments',
      label: 'Top N Documents',
      min: 3,
      max: 15,
      step: 1
    }
  }
)
